<template>
  <div
    class="menu-side bg--blue-dark tx--bege"
    id="menu"
    style="display: block !important; z-index: 100 !important;"
  >
    <div class="hold-menu">
      <div class="mobile_only popup_close close-animate">
        <a href="javascript:void(0)" @click="TOGGLE_MENU"><CloseSvg /></a>
      </div>
      <div class="mm-user">
        <div class="user_row">
          שלום {{ activeUser.name }}.
          <a href="javascript:void(0)" @click="logout()">התנתקות</a>
        </div>
        <router-link to="/messages" class="mm-my-msg">
          <div class="relative">
            <span
              v-show="
                activeUser &&
                  activeUser.doctor_messages &&
                  activeUser.doctor_messages.length
              "
              class="pathology-dot"
            ></span>
            <img src="/assets/img/svg/sm-mail.svg" />
          </div>
          <div>יש לך <span class="underline">הודעות</span></div>
        </router-link>
      </div>

      <div class="calander_select_doc">
        <select2 v-model="selectedDoctor" name="doctorSelect">
          <option value="">בחר רופא</option>
          <option
            :value="doctor.id"
            v-for="(doctor, index) in doctors"
            :key="index"
          >
            {{ doctor.name }}
          </option>
        </select2>
      </div>
      <nav class="menu">
        <template v-for="(item, i) in menuListMobile">
          <div v-if="item.isAccordion" :key="i" class="menu_item">
            <a class="menu_item_top ease" href="javascript:void(0)">
              {{ item.title }}
            </a>
            <div class="drop_bt" @click="dropMenu"><ArrowDownSvg /></div>
            <div class="drop_open bg--bege">
              <div
                v-for="child in item.children"
                :key="child.path"
                @click="CLOSE_MENU"
              >
                <router-link
                  class="drop_link flex flex--start"
                  :to="child.path"
                >
                  <DateSvg v-if="child.isDateSvg" />
                  <ListSvg v-if="child.isListSvg" />
                  {{ child.title }}
                </router-link>
              </div>
            </div>
          </div>

          <div
            v-else-if="item.target"
            :key="i + item.path"
            class="menu_item"
            @click="CLOSE_MENU"
          >
            <a
              :href="item.path"
              :target="item.target"
              class="menu_item_top ease"
              >{{ item.title }}</a
            >
          </div>

          <div v-else :key="item.path" class="menu_item" @click="CLOSE_MENU">
            <router-link class="menu_item_top ease" :to="item.path">
              {{ item.title }}
              <span v-if="matchesDocsType(item.path)">
                <Bell class="pathology-bell-mobile" />
                <div
                  v-if="hasUnwatchedDocs(item.type)"
                  class="pathology-dot-mobile"
                ></div>
              </span>
            </router-link>
          </div>
        </template>

        <div class="menu_item">
          <a
            class="menu_item_top ease"
            href="javascript:void(0)"
            @click="openUploadPolicies"
          >
            טעינת קובץ ביטוח
          </a>
        </div>
      </nav>
      <a href="tel:0747049400" class="phone-text flex flex--start">
        <img src="/assets/img/svg/ic-phone-white.svg" alt="" />
        <span>מוקד תמיכה:</span>
        <a>077-6450466</a>
      </a>
      <div class="logo" @click="onLogo">
        <LogoSvg />
      </div>
      <div class="head--pad">
        <div class="no_mobile head_search relative">
          <input
            class="head_search_input"
            type="text"
            placeholder="חיפוש לפי ת.ז"
            v-on:keypress="numbersOnly"
          />
          <input class="head_search_submit" type="submit" value="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoSvg from "../../assets/img/svg/logo.svg";
import CloseSvg from "../../assets/img/svg/close.svg";
import DateSvg from "../../assets/img/svg/ic-date.svg";
import Bell from "../../assets/img/svg/bell.svg";
import ListSvg from "../../assets/img/svg/ic-list.svg";
import ArrowDownSvg from "../../assets/img/svg/arrow_down_white.svg";
import UploadPolicies from "../Popups/UploadPolicies.vue";
import { mapActions, mapGetters } from "vuex";
import { menuListMobile } from "../../utilities/globals.js";

export default {
  name: "Menu",
  data() {
    return {
      selectedDoctor: this.$store.state.activeDoctor.id,
      menuListMobile
    };
  },
  computed: {
    ...mapGetters([
      "activeDoctor",
      "activeUser",
      "doctors",
      "hasUnwatchedDocs",
      "docsTypes"
    ])
  },
  methods: {
    ...mapActions(["TOGGLE_MENU", "CLOSE_MENU", "LOGOUT"]),
    numbersOnly(ev) {
      ev = ev ? ev : window.event;
      var charCode = ev.which ? ev.which : ev.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        ev.preventDefault();
      } else {
        return true;
      }
    },
    logout() {
      sessionStorage.removeItem("initial-route");
      this.LOGOUT().then(() => {
        this.$API.logout().then(() => this.$router.push("/"));
      });
    },
    dropMenu(el) {
      if ($(el.target).hasClass("active")) {
        $(el.target)
          .closest(".menu_item")
          .find(".drop_open")
          .slideUp();
        $(el.target)
          .closest(".menu_item")
          .find(".menu_item_top")
          .removeClass("active");
      } else {
        $(el.target)
          .closest(".menu_item")
          .find(".drop_open")
          .slideDown();
        $(el.target)
          .closest(".menu_item")
          .find(".menu_item_top")
          .addClass("active");
      }
      $(el.target).toggleClass("active");
    },
    onLogo() {
      if (this.$route.path === "/dashboard") this.CLOSE_MENU();
      else this.$router.push("/dashboard");
    },
    openUploadPolicies() {
      this.CLOSE_MENU();
      this.$modal.show(UploadPolicies);
    },
    matchesDocsType(path) {
      return Object.keys(this.docsTypes).some(key => path.includes(key));
    }
  },
  watch: {
    selectedDoctor(value) {
      this.$store.dispatch("SET_DOCTOR", value);
      this.$API.getRoomsByDoctor(this.activeDoctor.id).then(res => {
        if (res.data.data) {
          this.SET_DOCTOR_ROOMS(res.data.data);
        }
      });
    },
    $route(to, from) {
      this.CLOSE_MENU();
    }
  },
  components: {
    LogoSvg,
    CloseSvg,
    DateSvg,
    ListSvg,
    ArrowDownSvg,
    Bell
  }
};
</script>
